module.exports = "/assets/f9fb836203f23769d22cbca528fe59a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FB.png
// module id = 2490
// module chunks = 0